import { Icon } from "@zapier/zinnia-icons";
import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import styles from "./FloatingClearSelectionButton.module.css";

type Props = {
  clearSelection: () => void;
};

export const FloatingClearSelectionButton = ({ clearSelection }: Props) => {
  return (
    <Tooltip placement="left" content="Clear selection">
      <TooltipFocusableTrigger>
        <button
          type="button"
          className={styles.floatingClearSelectionButton}
          onClick={clearSelection}
          title="Clear selection"
        >
          <Icon name="formXCircle" color="GrayWarm6" size="24px" />
        </button>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
};
